const bespokeCriteriaReferenceGroup = ['Martin & Co Basingstoke'] as const

export type BespokeCriteriaReferenceGroup = (typeof bespokeCriteriaReferenceGroup)[number]

export const isBespokeCriteriaGroup = (
  referenceGroup?: string,
): referenceGroup is BespokeCriteriaReferenceGroup =>
  bespokeCriteriaReferenceGroup.includes(referenceGroup as BespokeCriteriaReferenceGroup)

interface BespokeCriteraConfig {
  referenceGroup: BespokeCriteriaReferenceGroup
  criteria: string[]
}

const fourteenDayChaseCycle =
  'This agent is on a 14-day chase cycle. Please DO NOT close the reference on documents or open banking. DO NOT chase for documents or open banking either. At the end of the chase cycle if the referee has not responded, do not complete with documents or open banking - close as one week old unverified.'

export const bespokeCriteriaConfigs: BespokeCriteraConfig[] = [
  {
    referenceGroup: 'Martin & Co Basingstoke',
    criteria: [fourteenDayChaseCycle],
  },
]
